import { css } from 'lit'
import tokens from '@lansforsakringar/core-tokens'

import { declare, scoped, vars } from '#utils/styles'

export const locals = scoped('section-header', ['color'] as const)

export default css`
	:host {
		${declare(locals, {
			color: tokens.color_text_brand_primary
		})};
		display: block;
		color: ${vars(locals.color)};

		& > :is(h1, h2, h3, h4, h5, h6) {
			margin-inline: ${vars(tokens.spacing_lg)};
			margin-block-start: ${vars(tokens.spacing_lg)};
			margin-block-end: ${vars(tokens.spacing_md)};
			font-family: ${vars(tokens.font_family_heading)};
			font-weight: ${vars(tokens.font_weight_bold)};
			font-size: ${vars(tokens.text_size_heading_level_4)};
			line-height: ${vars(tokens.line_height_heading_level_4)};
		}
	}
`
